export class LqdMaskSliderrHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initToggle();

  }

  getDefaultSettings() {
    return {
      selectors: {
        switchActiveElement: '[data-lqd-switch-active]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $switchActiveElement: this.$element.find(selectors.switchActiveElement),
    }
  }

  initToggle() {

    this.elements.$switchActiveElement.liquidSwitchActive();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdMaskSliderrHandler, { $element } );
};